import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../../../lib/supabase';
import './AccountSettings.css';

function ResetPasswordForm({ onClose, userEmail }) {
  const { t } = useTranslation(['profile', 'shared']);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    if (!userEmail) {
      setError(t('profile.settings.pages.account.resetPasswordForm.errorNoEmail'));
      return;
    }

    setLoading(true);

    try {
      // Wysyłka linku resetu hasła
      const { error: resetError } = await supabase.auth.resetPasswordForEmail(userEmail, {
        redirectTo: `${window.location.origin}/reset-password`
      });

      if (resetError) {
        throw resetError;
      }

      setSuccess(true);
    } catch (err) {
      console.error('Error sending password reset email:', err);
      setError(err.message || t('profile.settings.pages.account.resetPasswordForm.errorSend'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account-form-container">
      <h3 className="account-form-title">
        {t('profile.settings.pages.account.resetPasswordForm.title')}
      </h3>

      <form onSubmit={handleSubmit} className="account-form">
        <div className="account-form-field">
          <label className="account-form-label">
            {t('profile.settings.pages.account.resetPasswordForm.email')}
          </label>
          <div className="account-form-value">
            {userEmail || t('profile.settings.pages.account.notSet')}
          </div>
        </div>

        {error && (
          <div className="account-form-error">
            {error}
          </div>
        )}

        {success && (
          <div className="account-form-success">
            {t('profile.settings.pages.account.resetPasswordForm.success')}
          </div>
        )}

        <div className="account-form-info">
          {t('profile.settings.pages.account.resetPasswordForm.info')}
        </div>

        <div className="account-form-actions">
          <button
            type="button"
            onClick={onClose}
            className="account-form-button account-form-button-secondary"
            disabled={loading}
          >
            {success ? t('common.close') : t('common.cancel')}
          </button>
          {!success && (
            <button
              type="submit"
              className="account-form-button account-form-button-primary"
              disabled={loading}
            >
              {loading
                ? t('profile.settings.pages.account.resetPasswordForm.sending')
                : t('profile.settings.pages.account.resetPasswordForm.sendButton')
              }
            </button>
          )}
        </div>
      </form>
    </div>
  );
}

export default ResetPasswordForm;

